export default "__VITE_ASSET__d83b8d5d__"